export default function MenuIconBadge({
  count = 0,
  alert = false,
  alertTone = "amber",
  className = "",
  ariaLabel,
}) {
  if (alert) {
    const toneClass =
      alertTone === "red" ? " app-unread-badge--critical" : " app-unread-badge--alert";
    return (
      <span
        className={`app-unread-badge${toneClass}${className ? ` ${className}` : ""}`}
        aria-label={ariaLabel || "Action requise"}
      >
        !
      </span>
    );
  }

  if (!count || count <= 0) return null;

  return (
    <span
      className={`app-unread-badge${className ? ` ${className}` : ""}`}
      aria-label={`${count} notification${count > 1 ? "s" : ""} non consultée${count > 1 ? "s" : ""}`}
    >
      {count > 99 ? "99+" : count}
    </span>
  );
}
